import React, { useEffect, useState } from "react";

import Board from "./Board";

import { Get } from "utils/request";
import { CircularProgress } from "@mui/material";
import { Pagination } from "@mui/material";  
import { useDispatch } from "react-redux";
import { Show } from "actions/SnackbarActions";
import { useParams } from "react-router";

const Table = props => {

    const {
        search = ""
    } = props;

    const [users, SetUsers] = useState([]);
    const [loading, SetLoading] = useState(false);

    const [page, SetPage] = useState(1);
    const [maxPage, SetMaxPage] = useState(1);

    const { group_id } = useParams();

    const dispatch = useDispatch();

    const GetData = async () => {
        SetLoading(true);
        let response = await Get(`groups?id=${group_id}&searchUsers=${search}`);
        SetLoading(false);
        if (response?.status === true) {
            SetUsers(response?.group?.users);
        } else if (!response) dispatch(Show({
            show: true,
            message: "Falha ao carregar os alunos",
            severity: "warning"
        }));
    }

    useEffect(GetData, [search, page]);

    return (
        <div>
            <div className="table-responsive">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>E-mail</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!loading && users?.map((value, index) => (
                            <Board
                                key={index}
                                userId={value?.id}
                                name={value?.name}
                                email={value?.email}
                                OnDelete={GetData}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="w100 flex jcc">
                <CircularProgress hidden={!loading}/>
                <p hidden={users?.length !== 0 || loading}>Nenhum usuário foi achado</p>
            </div>
            <Pagination
                className={(maxPage == 1 ? "hide" : "")}
                style={{display: "flex", justifyContent: "flex-end"}} 
                count={maxPage} 
                value={page}
                onChange={(_, value) => SetPage(value)}
            />
        </div>
    );
}

export default Table;